export default function ReleaseNotesEditController(
  $window,
  $stateParams,
  $state,
  releaseNotesService,
  NotificationService,
  UtilService,
  EDITOR_CONSTANTS,
) {
  var vm = this;
  vm.isLoading = false;

  vm.newReleaseNote = {};
  vm.releaseNotes = [];

  vm.lang = $stateParams.language;

  vm.languages = EDITOR_CONSTANTS.LANGUAGES;

  vm.deleteReleaseNote = deleteReleaseNote;
  vm.updateReleaseNote = updateReleaseNote;
  vm.goToReleaseNote = goToReleaseNote;
  vm.isAddButtonDisabled = isAddButtonDisabled;
  vm.updateNotes = updateNotes;
  vm.addReleaseNotes = addReleaseNotes;

  init();
  function init() {
    getReleaseNote();
  }

  function getReleaseNote() {
    enableLoading();
    releaseNotesService
      .getReleaseNote(vm.lang)
      .then(function(res) {
        if (res.data) {
          vm.releaseNotes = res.data.releaseNoteDtos;
        }
      })
      .catch(function() {
        NotificationService.error('Cannot get release notes.');
      })
      .finally(function() {
        disableLoading();
      });
  }

  function updateReleaseNote() {
    const confirmation = $window.confirm(
      "The changes will affect the Business Center What's new section. Are you sure you want to continue?",
    );
    if (confirmation) {
      updateNotes(function() {
        vm.newReleaseNote = {};
      }, getReleaseNote);
    }
  }

  function addReleaseNotes(releaseNote) {
    releaseNote = prepareReleaseNotesForSave(releaseNote);
    vm.releaseNotes.push(releaseNote);
    updateReleaseNote();
  }

  function updateNotes(successCallback, finallyCallback) {
    enableLoading();
    releaseNotesService
      .updateReleaseNote(vm.lang, vm.releaseNotes)
      .then(function() {
        NotificationService.success('Release notes has been successfully updated');
        if (successCallback) {
          successCallback();
        }
      })
      .catch(function() {
        NotificationService.error('Cannot update release notes.');
      })
      .finally(function() {
        if (finallyCallback) {
          finallyCallback();
        }
        disableLoading();
      });
  }

  function prepareReleaseNotesForSave(releaseNote) {
    return Object.assign({}, releaseNote, {
      language: vm.lang,
      active: false,
    });
  }

  function deleteReleaseNote(releaseNote) {
    const confirmation = $window.confirm('Are you sure you want to delete this release note?');
    if (confirmation) {
      enableLoading();
      UtilService.deleteElementById(vm.releaseNotes, releaseNote.id);
      releaseNotesService
        .updateReleaseNote(vm.lang, vm.releaseNotes)
        .then(function() {
          NotificationService.success('Release note deleted');
        })
        .catch(function() {
          NotificationService.error('Cannot delete release note.');
        })
        .finally(function() {
          disableLoading();
        });
    }
  }

  function goToReleaseNote() {
    $state.transitionTo(
      $state.current,
      {
        language: vm.lang,
      },
      { reload: true },
    );
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }

  function isAddButtonDisabled() {
    return !vm.newReleaseNote.title || !vm.newReleaseNote.description || vm.isLoading;
  }
}



// WEBPACK FOOTER //
// ./src/app/content-editor/bc/releaseNotes/releaseNotes-edit.controller.js